import { FAIconName, Icon, Text } from "@/ui/core";
import type { BaseCardProps } from "@/ui/layout";
import { BaseCard, HStack } from "@/ui/layout";
import { ColorToken } from "@/ui/theme/tokens";
import { joinTestIDs } from "@/utils/string.util";

interface SelectableCardProps extends BaseViewProps {
  isSelected: boolean;
  label: string;
  maxWidth?: BaseCardProps["maxWidth"];
  onSelect: () => void;
}

const SelectableCard = ({
  accessibilityLabel,
  isSelected,
  label,
  maxWidth,
  onSelect,
  testID,
}: SelectableCardProps) => {
  const baseTestID = joinTestIDs(testID, "selectable");

  return (
    <BaseCard
      isSelected={isSelected}
      maxWidth={maxWidth}
      onPress={onSelect}
      testID={baseTestID}
      variant="secondary"
    >
      <HStack alignItems="center" justifyContent="space-between">
        <Text
          accessibilityLabel={accessibilityLabel}
          color={ColorToken.NeutralPrimary}
          testID={joinTestIDs(baseTestID, "title")}
          variant="bodyMedium"
        >
          {label}
        </Text>
        <Icon
          accessibilityLabel={`${label} selected`}
          color={ColorToken.Primary100}
          name={FAIconName.Check}
          opacity={isSelected ? 1 : 0}
          testID={joinTestIDs(baseTestID, "selected")}
        />
      </HStack>
    </BaseCard>
  );
};

export type { SelectableCardProps };
export default SelectableCard;
